module.exports = __webpack_public_path__ + "static/media/paint-roller.428b216f.jpg";